import { __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { BaseTag } from '../components/base-tag/Component.js';
import 'react-merge-refs';
import 'classnames';
import '@alfalab/hooks';

var defaultColors = {"filled":"tag__filled_v6akg"};
require('./default.mobile.css');

var invertedColors = {"filled":"tag__filled_1rwps"};
require('./inverted.mobile.css');

var styles = {"rectangular":"tag__rectangular_qbivf","size-32":"tag__size-32_qbivf","size-40":"tag__size-40_qbivf","size-48":"tag__size-48_qbivf","size-56":"tag__size-56_qbivf","size-64":"tag__size-64_qbivf","size-72":"tag__size-72_qbivf"};
require('./mobile.css');

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var TagMobile = forwardRef(function (restProps, ref) { return (React.createElement(BaseTag, __assign({}, restProps, { colorStylesMap: colorStyles, ref: ref, styles: styles }))); });

export { TagMobile };
